import React from "react";

import {
    View as RNView,
    ViewProps as RNViewProps,
    ViewStyle
} from "react-native";
import AppTheme from "../../utils/Theme";

interface ViewProps extends RNViewProps {
    safeArea?: "full" | "vertical" | "horizontal" | "top" | "bottom" | "left" | "right" | "none";
}

const View = (props: ViewProps) => {

    const { style, safeArea = "none", children, ...restProps } = props;

    const appTheme: AppTheme = new AppTheme();

    let safeAreaViewStyle: ViewStyle = {};
    if (safeArea !== "none") {
        let paddingTop: number = 0;
        let paddingBottom: number = 0;
        let paddingLeft: number = 0;
        let paddingRight: number = 0;
        if ((safeArea === "vertical") || (safeArea === "top")) {
            paddingTop = appTheme.topInsets;
        }
        if ((safeArea === "vertical") || (safeArea === "bottom")) {
            paddingBottom = appTheme.bottomInsets;
        }
        if ((safeArea === "horizontal") || (safeArea === "right")) {
            //paddingRight = safeAreaInsest.right;
        }
        if ((safeArea === "horizontal") || (safeArea === "left")) {
            //paddingLeft = safeAreaInsest.left;
        }

        safeAreaViewStyle = { paddingTop, paddingBottom, paddingLeft, paddingRight };
    }


    return <RNView style={[safeAreaViewStyle, style]} {...restProps}>
        {children}
    </RNView>
}

export default View;